import { render, staticRenderFns } from "./RequestInformationView.vue?vue&type=template&id=2228d234"
import script from "./RequestInformationView.vue?vue&type=script&lang=js"
export * from "./RequestInformationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports